import { render, staticRenderFns } from "./PriceWatcherButton.vue?vue&type=template&id=328d57d6&scoped=true"
import script from "./PriceWatcherButton.vue?vue&type=script&lang=js"
export * from "./PriceWatcherButton.vue?vue&type=script&lang=js"
import style0 from "./PriceWatcherButton.vue?vue&type=style&index=0&id=328d57d6&lang=scss&scoped=true"
import style1 from "./PriceWatcherButton.vue?vue&type=style&index=1&id=328d57d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d57d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328d57d6')) {
      api.createRecord('328d57d6', component.options)
    } else {
      api.reload('328d57d6', component.options)
    }
    module.hot.accept("./PriceWatcherButton.vue?vue&type=template&id=328d57d6&scoped=true", function () {
      api.rerender('328d57d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Home/PriceWatcherButton.vue"
export default component.exports